import { render, staticRenderFns } from "./SideEffectFormList.vue?vue&type=template&id=310bb063&scoped=true"
import script from "./SideEffectFormList.vue?vue&type=script&lang=js"
export * from "./SideEffectFormList.vue?vue&type=script&lang=js"
import style0 from "./SideEffectFormList.vue?vue&type=style&index=0&id=310bb063&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "310bb063",
  null
  
)

export default component.exports